document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.lb-qp').forEach(function(root){
    var trigger = root.querySelector('.lb-qp__trigger');
    var drawer = root.querySelector('.lb-qp__drawer');
    var backdrop = root.querySelector('.lb-qp__backdrop');
    var closeBtn = root.querySelector('.lb-qp__close');
    var lastFocus = null;
    function isDesktop(){ return window.matchMedia('(min-width: 990px)').matches }
    function openDrawer(){
      lastFocus = document.activeElement;
      trigger.setAttribute('aria-expanded','true');
      drawer.hidden = false; backdrop.hidden = false;
      backdrop.classList.add('is-visible');
      drawer.classList.toggle('is-open-right', isDesktop());
      drawer.classList.toggle('is-open-bottom', !isDesktop());
      setTimeout(function(){ closeBtn && closeBtn.focus() }, 10);
      document.addEventListener('keydown', onKey);
      window.addEventListener('resize', onResize);
    }
    function closeDrawer(){
      trigger.setAttribute('aria-expanded','false');
      backdrop.classList.remove('is-visible');
      drawer.classList.remove('is-open-right','is-open-bottom');
      setTimeout(function(){ drawer.hidden = true; backdrop.hidden = true }, 200);
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
      if(lastFocus) lastFocus.focus();
    }
    function onKey(e){ if(e.key === 'Escape'){ closeDrawer() } }
    function onResize(){ if(drawer.hidden) return; drawer.classList.toggle('is-open-right', isDesktop()); drawer.classList.toggle('is-open-bottom', !isDesktop()); }
    trigger && trigger.addEventListener('click', openDrawer);
    backdrop && backdrop.addEventListener('click', closeDrawer);
    closeBtn && closeBtn.addEventListener('click', closeDrawer);
  });
});
